"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Colors = __importStar(require("@material-ui/core/colors"));
exports.COLOR_NAME_REMOVED = 'common';
exports.getMaterialColorNames = function () {
    var colorNames = Object.keys(Colors);
    var colorNamesRemoveCommon = colorNames.filter(function (color) { return color !== exports.COLOR_NAME_REMOVED; });
    return colorNamesRemoveCommon;
};
var makeAllColorsArr = function () {
    var colorNamesRemoveCommon = exports.getMaterialColorNames();
    return colorNamesRemoveCommon.map(function (color) { return Colors[color]; });
};
var allColorsArr = makeAllColorsArr();
exports.default = allColorsArr;
